import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const NutritionIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M12.6 6.1h.1l3.1-1c1.8-.5 2.6-3.4 2.6-3.5 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3 0l-3.1.9c-1.7.4-2.5 3-2.6 3.4v.1c0 .3.1.4.3.4z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M16.3 7.4c-1.6-.1-3.2.6-4.3 1.8C10.9 8 9.3 7.4 7.7 7.4h-.1c-2.5.2-4.3 2.4-4.1 4.9 0 2.1.3 4.2 1 6.1l.6 1.2c.4.7.9 1.4 1.5 1.9 1 .7 2.1 1.1 3.3 1 1.6-.1 1.3-.4 2.1-.4s.4.5 2.9.5c2.8 0 5.7-3.8 5.7-10.4v-.1c.1-2.4-1.8-4.5-4.3-4.7z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default NutritionIcon;
